import axios from "axios";
import { API_BASE_URL } from "./BaseUrl";
import { getLanguage,setLanguage } from "./HelperFuncitons";
 

axios.interceptors.response.use((response) => response, (error) => {
   if (error?.response?.data?.code === "SITE_ACCESS_REQUIRED" && window.location.pathname !== "/manage-sites") {
      window.location.replace("/manage-sites");
   }
   
   if ((error?.response?.data?.status === 401) || error?.response?.status === 401) {
      localStorage.clear();
      window.location.pathname = "/login"
   } else {
      throw error
   }
});

export const postApiWithoutToken = (path, data) => {
   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         "Language": getLanguage() || "en"
      },
   });
};

export const putApiWithoutToken = (path, data) => {
   return axios.put(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         "Language": getLanguage() || "en"
      },
   });
};

export const postApiWithToken = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      },
   });
};

export const getApiWithToken = (path) => {
   const token = localStorage.getItem("token");
     
   return axios.get(API_BASE_URL + path, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      },
   });
};

export const imgUploadApi = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "multipart/form-data",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      },
   });
};

export const getApiWithoutToken =  (path) => {
   return  axios.get(API_BASE_URL + path, {
      headers: {
         "Content-Type": "application/json",
          "Language": getLanguage() || "en"
      },
   }
   );
};

export const putApiWithToken = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.put(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      },
   });
};

export const deleteApi = (path, data) => {
   const token = localStorage.getItem("token");
   return axios.delete(API_BASE_URL + path, {
      data: data,
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      }
   });
};


export const getDownloadApiWithToken = (path) => {
   const token = localStorage.getItem("token");

   return axios.get(API_BASE_URL + path, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      },
      responseType: 'blob', // Important to handle binary data
   });
};

export const postDownloadApiWithToken = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
         "Language": getLanguage() || "en"
      },
      responseType: 'blob',
   });
};

export const getUrlBolb = (path)=>{
   return axios.get(path, {
      headers: {
         "Content-Type": "application/json",
          "Language": getLanguage() || "en"
      },
      responseType: 'blob', // Important to handle binary data
   });
}
